import React from 'react';
import { View } from 'react-native';
import SideMenuItem from '../components/SideMenuItem';
import { LocStr } from '../utils/Utils';
import {
  Deliverables_str,
  development_str,
  Interaction_str, Keyboard_str,
  Onboarding_str,
  Send_str,
  Services_str,
  Theme_str,
} from '../utils/DictionaryManagementUtils';
import {
  img_developer_off,
  img_developer_on,
  img_interactions_off,
  img_interactions_on, img_keyboard_off, img_keyboard_on,
  img_deliverables_on, img_deliverables_off,
  img_onboarding_off,
  img_onboarding_on,
  img_send_off,
  img_send_on,
  img_services_off,
  img_services_on,
  img_theme_off,
  img_theme_on,
} from '../utils/ImagesManagementUtils';
import { DEVELOPMENT_MODE } from '../utils/ExternalKeys';

const SideMenuBar = ({
  handlePressOnTab,
  calcSelectedTab,
  language,
}) => {
  const categories = [
    { title: LocStr(Theme_str, language), imageSelected: img_theme_on, imageUnselected: img_theme_off },
    { title: LocStr(Services_str, language), imageSelected: img_services_on, imageUnselected: img_services_off },
    {
      title: LocStr(Interaction_str, language),
      imageSelected: img_interactions_on,
      imageUnselected: img_interactions_off,
    },
    {
      title: LocStr(Deliverables_str, language),
      imageSelected: img_deliverables_on,
      imageUnselected: img_deliverables_off,
    },
    {
      title: LocStr(Onboarding_str, language),
      imageSelected: img_onboarding_on,
      imageUnselected: img_onboarding_off,
    },
    {
      title: LocStr(Keyboard_str, language),
      imageSelected: img_keyboard_on,
      imageUnselected: img_keyboard_off,
    },
    { title: LocStr(Send_str, language), imageSelected: img_send_on, imageUnselected: img_send_off },
  ];
  if (DEVELOPMENT_MODE) {
    categories.push({ title: LocStr(development_str, language), imageSelected: img_developer_on, imageUnselected: img_developer_off });
  }
  const myStyles = {
    sideMenuBar: {
      borderLeft: 'solid 4px #f0f5f9',
      padding: 15,
    },
  };

  return (
    <View style={myStyles.sideMenuBar}>
      {categories.map((category, index) => (
        <SideMenuItem
          categoryObject={category}
          onPress={() => {
            handlePressOnTab(index);
          }}
          selected={calcSelectedTab() === index}
        />
      ))}
    </View>

  );
};

export default SideMenuBar;
